import { useMutation } from '@apollo/client'
import {
  type AttendanceToleranceSettingFragment,
  UpdateAttendanceToleranceSettingDocument,
} from 'generated/resources/graphql'

export const useUpdateToleranceSetting = () => {
  const [updateToleranceSetting, { loading }] = useMutation(
    UpdateAttendanceToleranceSettingDocument
  )

  return {
    loading,
    update(id: number, values: AttendanceToleranceSettingFragment) {
      return updateToleranceSetting({
        variables: {
          ...values,
          id,
        },
      })
    },
  }
}
